// libs
import React, { memo } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import DlsTextField from '@/widgets/DlsTextFeild/DlsTextField';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// widgets
import EditButton from '@/widgets/EditButton';
import SummaryTable from '@/widgets/SummaryTable';
const Placement = ({ className, name, mode, onNameChange, setActiveStep, }) => {
    const handleEditClick = () => {
        // Index 0 is for Placement screen
        setActiveStep(0);
    };
    return (React.createElement(SummaryTable.Table, { className: className },
        React.createElement(SummaryTable.Caption, null,
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Placement"),
            React.createElement(EditButton, { label: "Edit", onClick: handleEditClick })),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Campaign Name")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(DlsTextField, { textFieldDetails: {
                        isDisabled: true,
                        value: name,
                        type: TextFieldTypes.TEXT,
                        name: 'campaign-name-input',
                        label: '',
                        onChange: onNameChange,
                        attrs: { autoComplete: 'off' },
                    }, rightActionDetails: [
                        {
                            type: RightActionTypes.CLEAR,
                        },
                    ] }))),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Bidding Strategy")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Cost per Impressions"))),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Campaign Surface")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Swiggy instamart"))),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Campaign Type")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Keyword Ads")))));
};
export default memo(Placement);
